module.exports = __webpack_public_path__ + "img/bannerBG1.1adb740d.png";